// extracted by mini-css-extract-plugin
export default {"main":"RacingBars_main__lk2iz","chart":"RacingBars_chart__uDbwu","team":"RacingBars_team__DxDBk","progress":"RacingBars_progress__wrvT+","score":"RacingBars_score__LWJcf"};